import type {
  ConfirmationStatusType,
  SatuanPendidikanType,
} from 'types/kinerja-pelaksanaan'

type Cta = {
  isDisabled: boolean
  shouldConfirm: boolean
  href?: string
  text?: string
  onClick?: () => void
}

type GetCtaParams = {
  confirmationStatus: ConfirmationStatusType
  schoolStatus: SatuanPendidikanType
  confirmationPath?: string
  nextPath?: string
  nextText: string
  confirmationText: string
  onConfirmClick?: () => void
  onNextClick?: () => void
}

const DEFAULT_CTA: Cta = { isDisabled: false, shouldConfirm: false }

export function getCta(params: GetCtaParams): Cta {
  const config: Record<
    SatuanPendidikanType,
    Record<ConfirmationStatusType, Cta>
  > = {
    NEGERI: {
      UNCONFIRMED: {
        isDisabled: true,
        shouldConfirm: false,
        href: params.nextPath,
        text: params.nextText,
        onClick: undefined,
      },
      REJECTED: {
        isDisabled: false,
        shouldConfirm: true,
        href: params.confirmationPath,
        text: params.confirmationText,
        onClick: params.onConfirmClick,
      },
      CONFIRMED: {
        isDisabled: false,
        shouldConfirm: false,
        href: params.nextPath,
        text: params.nextText,
        onClick: params.onNextClick,
      },
    },
    SWASTA: {
      UNCONFIRMED: {
        isDisabled: false,
        shouldConfirm: true,
        href: params.confirmationPath,
        text: params.confirmationText,
        onClick: params.onConfirmClick,
      },
      REJECTED: {
        isDisabled: false,
        shouldConfirm: true,
        href: params.confirmationPath,
        text: params.confirmationText,
        onClick: params.onConfirmClick,
      },
      CONFIRMED: {
        isDisabled: false,
        shouldConfirm: false,
        href: params.nextPath,
        text: params.nextText,
        onClick: params.onNextClick,
      },
    },
  }

  return config[params.schoolStatus]?.[params.confirmationStatus] || DEFAULT_CTA
}
